// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1753Q","comment":"styles_comment__2qD9n"};